exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-scroll__viewport{display:inline-block;overflow-y:hidden}.igx-scroll__vertical{display:inline-block;width:20px;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/scroll/scroll.component.scss
// module id = 141
// module chunks = 0 1